import { useState, useEffect } from "react";
import toast from "../../utils/toast";
import { Link } from "react-router-dom";
import { hotSectionsApi } from "../../services";
import "./hotSections.css";

const PF = "https://backend.hoanglecf.com/images";

const TYPE_LABEL = {
  equipment: "Trang bị",
  news: "Tin tức",
  custom: "Tuỳ biến",
};

const LAYOUT_LABEL = {
  carousel: "Carousel",
  grid: "Lưới",
  list: "Danh sách",
};

export default function HotSections() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSections();
  }, []);

  const fetchSections = async () => {
    try {
      setLoading(true);
      const data = await hotSectionsApi.getAll();
      setSections(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching hot sections:", error);
      toast.error("Không thể tải danh sách khối nội dung!");
    } finally {
      setLoading(false);
    }
  };

  const toggleEnabled = async (section) => {
    try {
      await hotSectionsApi.update(section._id, { enabled: !section.enabled });
      fetchSections();
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi khi cập nhật trạng thái!");
    }
  };

  const move = async (index, dir) => {
    const target = index + dir;
    if (target < 0 || target >= sections.length) return;
    const reordered = [...sections];
    const [item] = reordered.splice(index, 1);
    reordered.splice(target, 0, item);
    setSections(reordered);
    try {
      await hotSectionsApi.reorder(reordered.map((s, i) => ({ id: s._id, order: i })));
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi khi sắp xếp!");
      fetchSections();
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Bạn có chắc muốn xoá khối nội dung này?")) return;
    try {
      await hotSectionsApi.remove(id);
      fetchSections();
      toast.success("Đã xoá khối nội dung!");
    } catch (error) {
      console.error(error);
      toast.error("Có lỗi khi xoá!");
    }
  };

  if (loading) {
    return (
      <div className="hs-page">
        <div className="hs-container">
          <div className="hs-loading">
            <i className="fas fa-spinner fa-spin"></i>
            <span>Đang tải...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="hs-page">
      <div className="hs-container">
        <div className="hs-page-header">
          <div className="hs-page-title">
            <h1>Khối nội dung nóng</h1>
            <p>Cập nhật trang bị nóng, tin tức nóng hiển thị trên trang chủ</p>
          </div>
          <Link to="/hot-sections/create" className="hs-btn hs-btn-primary">
            <i className="fas fa-plus"></i>
            <span>Tạo khối mới</span>
          </Link>
        </div>

        {sections.length === 0 ? (
          <div className="hs-empty">
            <i className="fas fa-fire"></i>
            <h3>Chưa có khối nội dung nào</h3>
            <p>Tạo khối đầu tiên để hiển thị trang bị / tin tức nóng</p>
            <Link to="/hot-sections/create" className="hs-btn hs-btn-primary">
              <i className="fas fa-plus"></i> Tạo khối đầu tiên
            </Link>
          </div>
        ) : (
          <div className="hs-list">
            {sections.map((s, index) => (
              <div key={s._id} className={`hs-card ${s.enabled ? "" : "is-disabled"}`}>
                <div className="hs-card-order">
                  <button
                    className="hs-icon-btn"
                    disabled={index === 0}
                    onClick={() => move(index, -1)}
                    title="Lên"
                  >
                    <i className="fas fa-chevron-up"></i>
                  </button>
                  <span className="hs-order-num">{index + 1}</span>
                  <button
                    className="hs-icon-btn"
                    disabled={index === sections.length - 1}
                    onClick={() => move(index, 1)}
                    title="Xuống"
                  >
                    <i className="fas fa-chevron-down"></i>
                  </button>
                </div>

                <div className="hs-card-thumbs">
                  {(s.items || []).slice(0, 4).map((it, i) =>
                    it.image ? (
                      <img key={i} src={`${PF}${it.image}`} alt={it.title || ""} />
                    ) : (
                      <div key={i} className="hs-thumb-placeholder">
                        <i className="fas fa-image"></i>
                      </div>
                    )
                  )}
                  {(s.items || []).length === 0 && (
                    <div className="hs-thumb-placeholder">
                      <i className="fas fa-image"></i>
                    </div>
                  )}
                </div>

                <div className="hs-card-info">
                  <h3>{s.title}</h3>
                  {s.subtitle && <p className="hs-card-sub">{s.subtitle}</p>}
                  <div className="hs-card-meta">
                    <span className="hs-chip">{TYPE_LABEL[s.type] || s.type}</span>
                    <span className="hs-chip">{LAYOUT_LABEL[s.layout] || s.layout}</span>
                    <span className="hs-chip">
                      <i className="fas fa-layer-group"></i> {(s.items || []).length} item
                    </span>
                    <span className={`hs-chip ${s.enabled ? "chip-on" : "chip-off"}`}>
                      {s.enabled ? "Đang hiện" : "Đang ẩn"}
                    </span>
                  </div>
                </div>

                <div className="hs-card-actions">
                  <button
                    className="hs-icon-btn"
                    onClick={() => toggleEnabled(s)}
                    title={s.enabled ? "Ẩn" : "Hiện"}
                  >
                    <i className={`fas ${s.enabled ? "fa-eye" : "fa-eye-slash"}`}></i>
                  </button>
                  <Link
                    to={`/hot-sections/edit/${s._id}`}
                    className="hs-icon-btn"
                    title="Chỉnh sửa"
                  >
                    <i className="fas fa-edit"></i>
                  </Link>
                  <button
                    className="hs-icon-btn hs-danger"
                    onClick={() => handleDelete(s._id)}
                    title="Xoá"
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
